



















































































































































import { Vue, Component, Ref, Prop, Watch, Emit } from 'vue-property-decorator'
import { VForm, DictFilter, DictParam, DictRequest } from '@/types'
import { EPLModule } from '../store/eplmodule'

@Component({
  name: 'DictForm',
  components: {
    UIField: () =>
      import(
        /* webpackChunkName: "UIField" */ '@/components/UIField.vue'
      )
  }
})
export default class DictForm extends Vue {
  @Prop() saveForm!: boolean
  @Prop(String) dictName!: string
  @Prop({ default: false }) routerBack!: boolean
  @Prop({ default: true }) showSaveAs!: boolean
  @Prop() mainFilter!: DictFilter
  // ! одиночная форма должна загрузить свои данные сама
  @Prop({ default: false }) alone!: boolean

  show = false
  tab = 0
  valid = true
  idx = -1
  atselectKey = 0
  cardHeight = 0

  @Ref('editform') editForm!: VForm

  @Watch('saveForm')
  onSaveForm () {
    if (this.saveForm) {
      this.save(false)
      this.updateSaveForm(false)
    }
  }

  @Emit('update:saveForm')
  updateSaveForm (val: boolean) { return val }

  @Emit('update-table')
  updateTable () { //
  }

  get dict () {
    return EPLModule.dicts[this.idx]
  }

  get lists () {
    return EPLModule.lists
  }

  get formTitle (): string {
    if (EPLModule.dicts[this.idx] === undefined) return ''
    return EPLModule.dicts[this.idx].currentRow.id === 0
      ? EPLModule.dicts[this.idx].fields.formtitle
      : 'Редактирование'
  }

  get loading (): number {
    return EPLModule.loading
  }

  async created () {
    this.idx = EPLModule.DictIdx(this.dictName)
    this.show = true
  }

  mounted () {
    // console.log('form mounted', this.dictName)
    // одиночная форма, пока нигде не используется
    if (this.alone) {
      const p = {} as DictParam
      p.idx = this.idx
      p.request = {} as DictRequest
      p.request.options = { page: 1, itemsPerPage: 1 }
      p.request.filter = []
      p.request.filter.push(this.mainFilter)
      EPLModule.fetchDictData(p).then(() => {
        EPLModule.showDictForm({
          id: EPLModule.dicts[this.idx].rows[0].id,
          idx: this.idx
        })
      })
    }
  }

  private tabChange (e: any) {
    this.tab = e
    const el = document.getElementById('mycard')
    if (el !== null) {
      if (this.cardHeight < el.clientHeight) { this.cardHeight = el.clientHeight + 2 }
    }
  }

  private isLockedField (name: string): boolean {
    // поле только для чтения если оно в списке исключений
    // но доступно для редактирования при создании новой записи
    let res = false
    const fields = EPLModule.dicts[this.idx].locked.fields
    const pos = fields.indexOf(name)
    if (pos === 0) { res = true }
    if (pos > 0) {
      if (fields[pos - 1] === ',') { res = true }
    }
    return (res && EPLModule.dicts[this.idx].currentRow.id > 0)
  }

  private isSignedField (name: string): boolean {
    // если это DriverTasks и стоит подпись заказчика, то нельзя редактировать
    if (this.dictName === 'DriverTasks') {
      if (EPLModule.dicts[this.idx].currentRow.signtime > 0) return true
    }
    let res = false
    const fields = EPLModule.dicts[this.idx].signedFields
    const pos = fields.indexOf(name)
    if (pos === 0) { res = true }
    if (pos > 0) {
      if (fields[pos - 1] === ',') { res = true }
    }
    // поле помечается подписанным
    return (res && EPLModule.dicts[this.idx].currentRow.id > 0)
  }

  private hidden (item: any): boolean {
    // скрывает поле при определённом значении другого поля
    if (item.hidden !== undefined) {
      const h = item.hidden as string
      const dict = h.split('.')
      return (dict[2].indexOf(EPLModule.dicts[EPLModule.DictIdx(dict[0])].currentRow[dict[1]]) >= 0)
    }
    return false
  }

  // костыль для обновления списка полей справочника для AccessTable
  private updateMultipleselect () {
    this.atselectKey++
  }

  private clickClose () {
    this.editForm.resetValidation()
    EPLModule.hideDictForm(this.idx)
    if (this.routerBack) this.$router.back()
  }

  private save (add: boolean): boolean {
    if (!this.editForm.validate()) {
      return false
    }
    if (add) {
      EPLModule.dicts[this.idx].currentRow.id = 0
    }
    if (this.mainFilter !== undefined) {
    // при работе с другими формами связаны по фильтру
    // для добавления значения устанавливаем поле из фильтра
    // при этом тип указываем в поле combine
      EPLModule.dicts[this.idx].currentRow[this.mainFilter.field] =
        this.mainFilter.combine === 'number'
          ? parseFloat(this.mainFilter.condition)
          : `${this.mainFilter.condition}`
    }
    EPLModule.saveDictCurrentRow({ idx: this.idx, hide: true })
      .then(() => {
        this.updateTable()
      })
    if (this.routerBack) this.$router.back()
    this.editForm.resetValidation()
    return true
  }
}
